/**
 * Avatar-related type definitions for player customization
 */

export enum HairStyle {
  Short = 'short',
  Long = 'long',
  Curly = 'curly',
  Ponytail = 'ponytail',
  Bald = 'bald',
}

export enum SkinColor {
  Light = 'light',
  Medium = 'medium',
  Dark = 'dark',
  Tan = 'tan',
}

export enum EyeColor {
  Brown = 'brown',
  Blue = 'blue',
  Green = 'green',
  Hazel = 'hazel',
}

export enum AccessoryType {
  None = 'none',
  Glasses = 'glasses',
  Sunglasses = 'sunglasses',
  Hat = 'hat',
}

export interface IAvatar {
  hairStyle: HairStyle;      // Used only when imageUrl is not available
  hairColor: string;         // Used only when imageUrl is not available
  skinColor: SkinColor;      // Used only when imageUrl is not available  
  eyeColor: EyeColor;        // Used only when imageUrl is not available
  accessory: AccessoryType;  // Used only when imageUrl is not available
  isSmiling: boolean;        // Used only when imageUrl is not available
  imageUrl?: string;         // Primary avatar representation - PNG image filename
}

export interface IAvatarOption {
  id: string;
  type: 'hair-style' | 'hair-color' | 'skin-color' | 'eye-color' | 'accessory' | 'expression';
  value: string | boolean;
  preview: string; // CSS class or image path for preview
}

export const DEFAULT_AVATAR: IAvatar = {
  hairStyle: HairStyle.Short,
  hairColor: '#8B4513',
  skinColor: SkinColor.Medium,
  eyeColor: EyeColor.Brown,
  accessory: AccessoryType.None,
  isSmiling: true,
};
